import { MetaPages } from '../../enums/pages';
import AboutContent from '../../components/molecules/about-content/about-content';
import ContainerWithSidebar from '../../components/atoms/container-with-sidebar/container-with-sidebar';
import HeaderContainer from '../../components/molecules/header-container/header-container';
import {
  getAboutBannerContent,
  getAboutSustainabilityContent
} from '../../services/about';
import Tabs from '../../components/molecules/tabs/tabs';
import { aboutRoutes } from '../../config/routes/pages';
import { ContentType } from '../../types/content';
import TabTitle from '../../components/atoms/tab-title/tab-title';

type IndexProps = {
  aboutBannerContent: ContentType;
  aboutSustainabilityContent: ContentType;
};

export function Index(props: IndexProps) {
  const { aboutBannerContent, aboutSustainabilityContent } = props;

  return (
    <>
      <TabTitle page={MetaPages.ABOUT_SUSTAINABILITY} />
      <HeaderContainer {...aboutBannerContent} />
      <Tabs tabItems={aboutRoutes} />
      <ContainerWithSidebar>
        <AboutContent {...aboutSustainabilityContent} />
      </ContainerWithSidebar>
    </>
  );
}

export async function getStaticProps() {
  const aboutBannerContent = await getAboutBannerContent();
  const aboutSustainabilityContent = await getAboutSustainabilityContent();

  return {
    props: {
      aboutBannerContent,
      aboutSustainabilityContent
    }
  };
}

export default Index;
